export default function createUUID() {
  return ('A' + 1e6 + -1e3 + -4e3 + -8e3 + -1e11)
    .replace(/[018]/g, (c) =>
      (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16),
    )
    .replace(/A/g, Math.floor(Math.random() * (15 - 10 + 1) + 10).toString(16));
}
